/**
 * Monta o objeto validado por envSchema a partir de variáveis de ambiente.
 * Usado em appSettings (import.meta.env) e no vite.config (loadEnv) para validar no build.
 */
export function buildEnvConfig(
  env: Record<string, string | undefined>
): Record<string, unknown> {
  return {
    algolia: {
      apiKey: env.VITE_ALGOLIA_KEY,
      appID: env.VITE_ALGOLIA_APP_ID,
      index: {
        specialtyDoctor: env.VITE_ALGOLIA_INDEX_SPECIALTY_DOCTOR,
        local: env.VITE_ALGOLIA_INDEX_LOCAL,
        healthCarrier: env.VITE_ALGOLIA_INDEX_HEALTH_CARRIER,
        healthPlan: env.VITE_ALGOLIA_INDEX_HEALTH_PLAN
      }
    },
    patientArea: {
      baseUrl: env.VITE_PATIENT_AREA_BASE_URL,
      clientId: env.VITE_PATIENT_AREA_CLIENT_ID,
      login: env.VITE_PATIENT_AREA_LOGIN,
      refreshTokenUrl: env.VITE_PATIENT_AREA_REFRESH_PATH
    },
    publicUrl: env.VITE_URL,
    agHistoryBaseUrl: env.VITE_AG_HISTORY_BASE_URL,
    niceChatToken: env.VITE_NICECHAT_TOKEN,
    recaptchaToken: env.VITE_RECAPTCHA_KEY_SITE,
    apiClientId: env.VITE_API_CLIENT_ID,
    apiHealthCardAIClientId: env.VITE_API_HEALTH_CARD_AI_CLIENT_ID,
    doctorAvatarUrlBase: env.VITE_DOCTOR_AVATAR_URL_BASE,
    bannerAppAPUrl: env.VITE_BANNER_APP_AP_URL,
    bannerAppIOSUrl: env.VITE_BANNER_APP_IOS_URL,
    apiBaseUrl: env.VITE_API_BASE_URL,
    apiHealthCardAIUrl: env.VITE_API_HEALTH_CARD_AI_BASE_URL,
    apiScheduleSocketBaseUrl: env.VITE_API_SCHEDULE_SOCKET_BASE_URL,
    apiScheduleSocketAuth: env.VITE_API_SCHEDULE_SOCKET_AUTH,
    apiGoogleMaps: env.VITE_API_GOOGLE_MAPS,
    gtmId: env.VITE_GTM_ID,
    mixPanelToken: env.VITE_MIXPANEL_TOKEN,
    apmRumServer: env.VITE_APM_RUM_SERVER_URL,
    whatsAppNumber: env.VITE_WHATS_APP_NUMBER,
    scheduleLeadWebhook: {
      active: env.VITE_SCHEDULE_LEAD_WEBHOOK_ACTIVE === 'true',
      utmSource: 'tuasaude',
      token: env.VITE_SCHEDULE_LEAD_WEBHOOK_TOKEN,
      gaCookieName: env.VITE_SCHEDULE_LEAD_WEBHOOK_GA_COOKIE_NAME
    },
    sentryDSN: env.VITE_SENTRY_DSN,
    billingFraudWebsiteLink: env.VITE_BILLING_FRAUD_WEBSITE_LINK
  }
}
